import AbstractDecorator from "./AbstractDecorator.js";

/**
 * Strategy decorating the items by groups.
 *
 * @param {function(object): Renderable} [groupLabelRenderer] - Takes
 *   the group's key as argument and returns what should be rendered
 *   as a title for this group. Defaults to the key.
 * @param {function(object, object): integer} [compareFunction] - Takes
 *   two group keys as argument and return a sorting value
 */
export default class GroupByDecorator extends AbstractDecorator {
	constructor({ groupLabelRenderer = (key) => key, compareFunction }) {
		super(...arguments);

		this._groupLabelRenderer = groupLabelRenderer;
		this._compareFunction = compareFunction;
	}

	cssClass() {
		return "GroupByDecorator";
	}

	itemsRenderer({ items: groups }) {
		const sortedGroups = this._sortItems({ groups });

		return (html) => {
			html.div(sortedGroups.map((group) => this._groupRenderer(group)));
		};
	}

	_sortItems({ groups }) {
		if (!this._compareFunction) return groups;
		return [...groups].sort((a, b) => this._compareFunction(a.key, b.key));
	}

	_groupRenderer({ key, value }) {
		return (html) => {
			html.h3(
				{ "data-test": "card-group-title" },
				this._groupLabelRenderer(key),
			);

			html.div(
				{ class: this._strategy.cssClass() },
				this._strategy.itemsRenderer({ items: value }),
			);
		};
	}
}
